import React, { useState, useEffect } from 'react';
import axios from 'axios';

const FeedbackForm = (props) => {
    const [saved, setSaved] = useState();
    const [satisfaction, setSatisfaction] = useState();
    const [feedbackText, setFeedbackText] = useState();

    const changeSatisfaction = (value) => {
        setSatisfaction(value);
    }
    const changeFeedback = (value) => {
        setFeedbackText(value);
    }
    const saveFeedback = (e) => {
        e.preventDefault();
        setSaved(false);
        axios.post('api/feedback/' , {
            "satisfaction": satisfaction,
            "feedbackText": feedbackText,
            "uniqueToken": props.uniqueID
        }, { withCredentials: true }).then(response => {
            setSaved(true);
        })
    }
    return (
        <div >
            <p>How satisfied are you with the DUC Tool?</p>
            <div className="radioBlock">
                <div>
                    <input type="radio" id="1" name="satisfied" value="Very unsatisfied" onChange={(e) => changeSatisfaction(e.target.value)} />
                    <label htmlFor="1">&nbsp;Very unsatisfied</label>
                </div>
                <div>
                    <input type="radio" id="2" name="satisfied" value="Unsatisfied" onChange={(e) => changeSatisfaction(e.target.value)}/>
                    <label htmlFor="2">&nbsp;Unsatisfied</label>
                </div>
                <div>
                    <input type="radio" id="3" name="satisfied" value="Neutral" onChange={(e) => changeSatisfaction(e.target.value)}/>
                    <label htmlFor="3">&nbsp;Neutral</label>
                </div>
                <div>
                    <input type="radio" id="4" name="satisfied" value="Satisfied" onChange={(e) => changeSatisfaction(e.target.value)}/>
                    <label htmlFor="4">&nbsp;Satisfied</label>
                </div>
                <div>
                    <input type="radio" id="5" name="satisfied" value="Very satisfied" onChange={(e) => changeSatisfaction(e.target.value)}/>
                    <label htmlFor="5">&nbsp;Very satisfied</label>
                </div>
            </div>
            <br />
            <p>How can the DUC Tool be improved? </p>
            <textarea rows="5" onChange={(e) => changeFeedback(e.target.value)}></textarea>
            <a href="#" onClick={saveFeedback} className="link-small" >Send feedback</a>
            {saved ? <p>Thank you for your time and feedback.</p> : <div />}

            </div>
        
        )
}
export default FeedbackForm;